import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Tool error:", error, info.componentStack);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="panel" style={{ maxWidth: 520, margin: "40px auto" }}>
          <h2 style={{ marginTop: 0 }}>Something went wrong</h2>
          <p className="muted-note">{this.state.error.message}</p>
          <div className="button-row">
            <button
              className="primary-button"
              onClick={() => this.setState({ error: null })}
              type="button"
            >
              Try again
            </button>
            <a className="secondary-button" href="/">Back to home</a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
